/**
 * Central mock configuration based on environment variables
 *
 * IMPORTANT: Mocks are ONLY enabled via REACT_APP_USE_MOCKS environment variable.
 * NO automatic fallback when backend is unavailable - if API fails, error should be shown.
 */

export const MOCK_CONFIG = {
  // Master switch for ALL mocks - ONLY controlled by env variable
  enabled: false, // FORZA DISABILITATO - era: process.env.REACT_APP_USE_MOCKS === 'true'

  // Optional: enable specific modules (future expansion)
  modules: {
    tasks: true,
    contacts: true,
    users: true,
    team: true,
    agenda: true,
    appointments: true,
    emails: true,
    notifications: true,
    ai_agent: true,
  },

  // Simulated network delay (ms) for realistic behavior
  delay: {
    min: 200,
    max: 500,
  },
};

/**
 * Check if mocks are enabled globally
 * @returns {boolean}
 */
export const isMockEnabled = () => {
  return MOCK_CONFIG.enabled;
};

/**
 * Check if a specific module mock is enabled
 * @param {string} moduleName - Module name (e.g., 'tasks', 'contacts')
 * @returns {boolean}
 */
export const isModuleMockEnabled = (moduleName) => {
  return MOCK_CONFIG.enabled && MOCK_CONFIG.modules[moduleName] !== false;
};

/**
 * Get random delay for simulating network latency
 * @returns {number} Random delay in milliseconds
 */
export const getRandomDelay = () => {
  const { min, max } = MOCK_CONFIG.delay;
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
